// @ts-strict-ignore
import { Component, ChangeDetectionStrategy } from "@angular/core";
import { AbstractFlatWidget } from "src/app/shared/components/flat/abstract-flat-widget";
import { Modal } from "src/app/shared/components/flat/flat";
import { ChannelAddress, CurrentData, Utils } from "src/app/shared/shared";

import { ModalComponent } from "../modal/modal";

@Component({
    selector: "Common_Selfconsumption",
    templateUrl: "./flat.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class FlatComponent extends AbstractFlatWidget {
    public calculatedSelfConsumption: number | null;
    protected modalComponent: Modal | null = null;
    /**
     * Ob diese Edge einen echten Netz-Zähler hat - ohne Zähler ist
     * Eigennutzung nicht sinnvoll berechenbar (Sum-Baustein liefert sonst
     * immer 100%). Siehe [[project_excello_teuschnitz_pv_monitoring]].
     */
    private hasGridMeter: boolean = true;

    protected override afterIsInitialized(): void {
        this.modalComponent = this.getModalComponent();
        this.hasGridMeter = this.config
            ?.getComponentsImplementingNature("io.openems.edge.meter.api.ElectricityMeter")
            .some(c => c.isEnabled && this.config.isTypeGrid(c)) ?? true;
    }
    protected getModalComponent(): Modal {
        return { component: ModalComponent };
    }

    protected override getChannelAddresses() {
        return [new ChannelAddress("_sum", "GridActivePower"), new ChannelAddress("_sum", "ProductionActivePower")];
    }

    protected override onCurrentData(currentData: CurrentData) {
        this.calculatedSelfConsumption = this.hasGridMeter
            ? Utils.calculateSelfConsumption(
                Utils.multiplySafely(currentData.allComponents["_sum/GridActivePower"], -1),
                currentData.allComponents["_sum/ProductionActivePower"],
            )
            : null;
    }
}
